/**
 * Clean empty parameters from search object
 */
export const cleanEmptyParams = <T>(search: T): Partial<T> => {
  if (typeof search !== 'object' || search === null || Array.isArray(search)) {
    return {};
  }

  const newSearch = { ...search } as Record<string, unknown>;

  Object.keys(newSearch).forEach((key) => {
    const value = newSearch[key];
    if (
      value === undefined ||
      value === null ||
      value === '' ||
      (Array.isArray(value) && value.length === 0) ||
      (typeof value === 'number' && Number.isNaN(value))
    ) {
      delete newSearch[key];
    }
  });
  return newSearch as Partial<T>;
};
